import { makeSelectors } from '@utils/css';

const inputWrapper = "dibixpj03p";
const input = "dibi1eewa6u";
const pencil = "dibp1fbwspi";
const selectors = makeSelectors({
  input,
  pencil
});

export { input, inputWrapper, pencil, selectors };
import "./edit-input.style.linaria.module.css";
//# sourceMappingURL=edit-input.style.js.map
